/**
 * The page's title: the owner's name for the site, and a level's title then
 * the name for a level ("Riot Games - Kashif Nazir"). The static pages use it
 * at build time (build/content), and the app keeps the tab's title on the
 * level that's open as a visitor moves between levels.
 */
import type { ReadableStore } from "../core/store";

export function pageTitle(owner: string, page?: string): string {
  return page ? `${page} - ${owner}` : owner;
}

/** Keeps `doc.title` on the open level, by its title in the content index. */
export function followLevelTitle(
  doc: { title: string },
  world: ReadableStore<{ readonly levelId: string | null }>,
  levels: readonly { readonly id: string; readonly title: string }[],
  owner: string,
): void {
  const update = () => {
    const { levelId } = world.getSnapshot();
    doc.title = pageTitle(owner, levels.find((level) => level.id === levelId)?.title);
  };
  update();
  world.subscribe(update);
}
